import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { IUserSubscriptionStore } from './types';

export const useUserSubscriptionStore = create<IUserSubscriptionStore>()(
  devtools((set) => ({
    subscription: null,
    setSubscription: (subscription) => set({ subscription }),

    isSubscriptionLoading: false,
    setIsSubscriptionLoading: (isSubscriptionLoading) => set({ isSubscriptionLoading }),
  })),
);
